"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itemLabelFilter = exports.MultiSelect = void 0;
var _autocomplete = _interopRequireWildcard(require("@clayui/autocomplete"));
var _button = require("@clayui/button");
var _form = require("@clayui/form");
var _shared = require("@clayui/shared");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _Labels = require("./Labels");
var _excluded = ["active", "allowsCustomLabel", "alignmentByViewport", "children", "clearAllTitle", "closeButtonAriaLabel", "defaultActive", "defaultItems", "defaultValue", "disabled", "disabledClearAll", "hotkeysDescription", "inputName", "inputValue", "isLoading", "isValid", "items", "liveRegion", "locator", "loadingState", "menuRenderer", "messages", "onActiveChange", "onChange", "onClearAllButtonClick", "onItemsChange", "onLoadMore", "placeholder", "size", "sourceItems", "spritemap", "value"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var MultiSelect = exports.MultiSelect = /*#__PURE__*/_react.default.forwardRef(function MultiSelectInner(_ref, ref) {
  var externalActive = _ref.active,
    _ref$allowsCustomLabe = _ref.allowsCustomLabel,
    allowsCustomLabel = _ref$allowsCustomLabe === void 0 ? true : _ref$allowsCustomLabe,
    alignmentByViewport = _ref.alignmentByViewport,
    children = _ref.children,
    _ref$clearAllTitle = _ref.clearAllTitle,
    clearAllTitle = _ref$clearAllTitle === void 0 ? 'Clear All' : _ref$clearAllTitle,
    _ref$closeButtonAriaL = _ref.closeButtonAriaLabel,
    closeButtonAriaLabel = _ref$closeButtonAriaL === void 0 ? 'Remove {0}' : _ref$closeButtonAriaL,
    _ref$defaultActive = _ref.defaultActive,
    defaultActive = _ref$defaultActive === void 0 ? false : _ref$defaultActive,
    _ref$defaultItems = _ref.defaultItems,
    defaultItems = _ref$defaultItems === void 0 ? [] : _ref$defaultItems,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? '' : _ref$defaultValue,
    disabled = _ref.disabled,
    disabledClearAll = _ref.disabledClearAll,
    hotkeysDescription = _ref.hotkeysDescription,
    inputName = _ref.inputName,
    inputValue = _ref.inputValue,
    _i = _ref.isLoading,
    _ref$isValid = _ref.isValid,
    isValid = _ref$isValid === void 0 ? true : _ref$isValid,
    externalItems = _ref.items,
    liveRegion = _ref.liveRegion,
    _ref$locator = _ref.locator,
    locator = _ref$locator === void 0 ? {
      id: 'key',
      label: 'label',
      value: 'value'
    } : _ref$locator,
    loadingState = _ref.loadingState,
    MenuRenderer = _ref.menuRenderer,
    _ref$messages = _ref.messages,
    messages = _ref$messages === void 0 ? {
      hotkeys: 'Press backspace to delete the current row.',
      labelAdded: 'Label {0} added to the list',
      labelRemoved: 'Label {0} removed to the list',
      listCount: '{0} option available.',
      listCountPlural: '{0} options available.',
      loading: 'Loading...',
      notFound: 'No results found'
    } : _ref$messages,
    onActiveChange = _ref.onActiveChange,
    onChange = _ref.onChange,
    onClearAllButtonClick = _ref.onClearAllButtonClick,
    onItemsChange = _ref.onItemsChange,
    onLoadMore = _ref.onLoadMore,
    placeholder = _ref.placeholder,
    size = _ref.size,
    _ref$sourceItems = _ref.sourceItems,
    sourceItems = _ref$sourceItems === void 0 ? null : _ref$sourceItems,
    spritemap = _ref.spritemap,
    externalValue = _ref.value,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var containerRef = (0, _react.useRef)(null);
  var inputRef = (0, _react.useRef)(null);
  var lastChangesRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  var _useControlledState = (0, _shared.useControlledState)({
      defaultName: 'defaultItems',
      defaultValue: defaultItems,
      handleName: 'onItemsChange',
      name: 'items',
      onChange: onItemsChange,
      value: externalItems
    }),
    _useControlledState2 = _slicedToArray(_useControlledState, 2),
    items = _useControlledState2[0],
    setItems = _useControlledState2[1];
  var _useControlledState3 = (0, _shared.useControlledState)({
      defaultName: 'defaultValue',
      defaultValue: defaultValue,
      handleName: 'onChange',
      name: 'value',
      onChange: onChange,
      value: externalValue !== null && externalValue !== void 0 ? externalValue : inputValue
    }),
    _useControlledState4 = _slicedToArray(_useControlledState3, 2),
    value = _useControlledState4[0],
    setValue = _useControlledState4[1];
  var _useControlledState5 = (0, _shared.useControlledState)({
      defaultName: 'defaultActive',
      defaultValue: defaultActive,
      handleName: 'onActiveChange',
      name: 'active',
      onChange: onActiveChange,
      value: externalActive
    }),
    _useControlledState6 = _slicedToArray(_useControlledState5, 2),
    active = _useControlledState6[0],
    setActive = _useControlledState6[1];
  var inputElementRef = ref || inputRef;
  var ariaDescriptionId = (0, _shared.useId)();
  var hasAsyncItems = !!onLoadMore || typeof loadingState === 'number';
  var Container = MenuRenderer ? _shared.FocusScope : _react.default.Fragment;
  var containerProps = MenuRenderer ? {
    arrowKeysUpDown: false
  } : {};

  // Throws the warning only when the component is mounted and avoids
  // throwing it every time a rerender happens.
  (0, _react.useEffect)(function () {
    if (MenuRenderer) {
      console.warn("<ClayMultiSelect />: You are using 'menuRenderer' which is deprecated and missing the new features and improvements that have been implemented in the component try to migrate to the new composition based API to custom list items.");
    }
  }, []);
  (0, _react.useEffect)(function () {
    // Backward compatibility with the `menuRenderer` API.
    if (MenuRenderer && sourceItems) {
      setActive(!!value && sourceItems.length !== 0);
    }
  }, [value, sourceItems]);
  var memoizedChildren = (0, _react.useCallback)(function (item) {
    if (children && typeof children === 'function') {
      var child = children(item);
      return /*#__PURE__*/_react.default.cloneElement(child, {
        onClick: function onClick(event) {
          if (child.props.onClick) {
            child.props.onClick(event);
          }
          if (event.defaultPrevented) {
            return;
          }
          event.preventDefault();
          setActive(false);
          setItems([].concat(_toConsumableArray(items), [item]));
          setValue('');
        }
      });
    }
    return /*#__PURE__*/_react.default.createElement(_autocomplete.Item, {
      key: item[locator.value],
      onClick: function onClick(event) {
        event.preventDefault();
        setActive(false);
        setItems([].concat(_toConsumableArray(items), [item]));
        setValue('');
      }
    }, item[locator.label]);
  }, [children, locator]);
  return /*#__PURE__*/_react.default.createElement(Container, containerProps, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('form-control form-control-tag-group input-group', _defineProperty({
      focus: isFocused && isValid
    }, "form-control-tag-group-".concat(size), size)),
    ref: containerRef
  }, /*#__PURE__*/_react.default.createElement(_autocomplete.Autocomplete, _extends({}, otherProps, {
    UNSAFE_loadingShrink: true,
    active: MenuRenderer ? false : active,
    allowsCustomLabel: allowsCustomLabel,
    ariaDescriptionId: ariaDescriptionId,
    as: _Labels.Labels,
    closeButtonAriaLabel: closeButtonAriaLabel,
    containerElementRef: containerRef,
    defaultItems: !hasAsyncItems ? sourceItems : undefined,
    disabled: disabled,
    filterKey: locator.label,
    inputName: inputName,
    items: hasAsyncItems ? sourceItems : undefined,
    labels: items,
    lastChangesRef: lastChangesRef,
    loadingState: loadingState,
    locator: locator,
    menuTrigger: "focus",
    messages: messages,
    onActiveChange: MenuRenderer ? function () {} : setActive,
    onChange: setValue,
    onFocus: MenuRenderer && sourceItems ? function (event) {
      if (otherProps.onFocus) {
        otherProps.onFocus(event);
      }
      setActive(!!value && sourceItems.length !== 0);
    } : otherProps.onFocus,
    onFocusChange: setIsFocused,
    onItemsChange: hasAsyncItems ? function () {} : undefined,
    onLabelsChange: setItems,
    onLoadMore: onLoadMore,
    placeholder: placeholder,
    ref: inputElementRef,
    spritemap: spritemap,
    suggestionList: sourceItems !== null && sourceItems !== void 0 ? sourceItems : [],
    value: value
  }), memoizedChildren), sourceItems && MenuRenderer && sourceItems.length > 0 && /*#__PURE__*/_react.default.createElement(_autocomplete.default.DropDown, {
    active: active,
    alignElementRef: containerRef,
    alignmentByViewport: alignmentByViewport,
    onActiveChange: setActive
  }, /*#__PURE__*/_react.default.createElement(MenuRenderer, {
    inputValue: value,
    locator: locator,
    onItemClick: function onItemClick(item) {
      setItems([].concat(_toConsumableArray(items), [item]));
      setValue('');
      if (inputElementRef.current) {
        inputElementRef.current.focus();
      }
    },
    sourceItems: sourceItems,
    value: value
  })), !disabled && !disabledClearAll && (value || items.length > 0) && /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupItem, {
    shrink: true
  }, /*#__PURE__*/_react.default.createElement(_button.ClayButtonWithIcon, {
    "aria-label": clearAllTitle,
    borderless: true,
    className: "component-action",
    displayType: "secondary",
    onClick: function onClick() {
      if (onClearAllButtonClick) {
        onClearAllButtonClick();
      } else {
        setItems([]);
        setValue('');
      }
      if (inputElementRef.current) {
        inputElementRef.current.focus();
      }
    },
    outline: true,
    spritemap: spritemap,
    symbol: "times-circle",
    title: clearAllTitle
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "sr-only"
  }, /*#__PURE__*/_react.default.createElement("span", {
    id: ariaDescriptionId
  }, hotkeysDescription !== null && hotkeysDescription !== void 0 ? hotkeysDescription : messages.hotkeys), /*#__PURE__*/_react.default.createElement("span", {
    "aria-live": "polite",
    "aria-relevant": "text"
  }, lastChangesRef.current ? (0, _shared.sub)(liveRegion ? liveRegion[lastChangesRef.current.action] : lastChangesRef.current.action === 'added' ? messages.labelAdded : messages.labelRemoved, [lastChangesRef.current.label]) : null))));
});

/**
 * Utility used for filtering an array of items based off the locator which
 * is set to `label` by default.
 * @deprecated since v3.95.2 - it is no longer necessary...
 */
var itemLabelFilter = exports.itemLabelFilter = function itemLabelFilter(items, _value) {
  var _locator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'label';
  return items;
};